export default __webpack_public_path__ + "59467e0bf39e848faf26f1dfafcbf072.svg";